import type { AppFeatures } from './types/configurationFlags';

export const CONFIGURATION_FLAGS: AppFeatures = {
  payments: true,
  externalRegistrationData: true,
  feedback: true,
  outstandingBalance: true,
  multiBeneficiary: true,
  connectingFlights: false,
  oneTimePurchaseAncillaries: false,
  quotaBreakdown: false,
  receipts: true,
  faqPage: true,
  aggregatedAvailabilities: {
    searchAnywhere: true,
    customGroups: true,
    dateCarouselPreFill: true,
    optionalSearchDates: true,
  },
  infantSeatSelection: true,
  detailedPriceBreakdown: false,
  seatsLeft: {
    threshold: 5,
  },
};
